import Vue from 'vue'
import Router from 'vue-router'
import CheckLists from '../components/CheckLists/CheckLists'
import KnowledgeBase from '../components/KnowledgeBase/KnowledgeBase'
import Training from '../components/Training'
import Documents from '../components/Documents'
import Faq from '../components/FAQ/Faq'
import People from '../components/People/People'
import MainPage from '../components/MainPage/MainPage'
import NotFound from '../components/NotFound'

Vue.use(Router);

export default
new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: MainPage
        },
        {
            path: '*',
            name: 'not-found',
            component: NotFound
        },
        {
            path: '/check-lists',
            name: 'check-lists',
            component: CheckLists,
            children: [
                {
                    path: ':id',
                    name: 'list-post',
                    component: CheckLists
                },
            ]
        },
        {
            path: '/knowledge-base',
            name: 'knowledge-base',
            component: KnowledgeBase,
            children: [
                {
                    path: ':id',
                    name: 'knowledge-base-post',
                    component: KnowledgeBase
                },
                {
                    path: 'archive/:id',
                    name: 'knowledge-base-archive',
                    component: KnowledgeBase
                }
            ]
        },
        {
            path: '/training',
            name: 'training',
            component: Training
        },
        {
            path: '/documents',
            name: 'documents',
            component: Documents
        },
        {
            path: '/faq',
            name: 'faq',
            component: Faq
        },
        {
            path: '/people',
            name: 'people',
            component: People,
            children: [
                {
                    path: ':id',
                    name: 'people-post',
                    component: People
                },
            ]
        },
    ]
})
